/*
 * @Author: your name
 * @Date: 2021-11-10 23:27:16
 * @LastEditTime: 2022-05-06 02:30:31
 * @LastEditors: liuwujiang@easyretailpro.com liuwujiang@easyretailpro.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\router.js
 */
import Vue from 'vue'
import Router from 'vue-router'

// const originalPush = Router.prototype.push
//   Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '',
  routes: [
    {
      path: '/',
      name: 'home',
      component: ()=> import('./views/layout/index.vue'),      
      beforeEnter: (to, from, next) => {  
        next();  
      },  
      children: [
        {
          path: '',  
          name: 'home',  
          component: () => import(/* webpackChunkName: "header" */ './views/home/index.vue'),  
          meta:{
            navbar: {
              isShow: true,
              isBack: false
            },
            tabbar: {
              isShow: true,
              active: 1
            },
            title: "数字化全域经销商体系" // 首页
          },
        },  
        {
          path: '/dealer-archives',
          name: 'dealer-archives',
          component: ()=> import(/* webpackChunkName: "search" */'./views/dealer-archives/index.vue'),
          meta:{
            navbar: {
              isShow: true,
              isBack: true
            },
            tabbar: {
              isShow: true,
              active: 2
            },
            title: "数字化全域经销商体系" // 经销商档案
          }
        },
        {
          path: '/dealer-archives-detail',
          name: 'dealer-archives-detail',
          component: ()=> import(/* webpackChunkName: "search" */'./views/dealer-archives-detail/index.vue'),
          meta:{
            navbar: {
              isShow: true,
              isBack: true
            },
            tabbar: {
              isShow: true,
              active: 2
            },
            title: "数字化全域经销商体系" // 经销商档案详情
          }
        },
        {
          path: '/dealer-assess-catalogue',
          name: 'dealer-assess-catalogue',
          component: ()=> import(/* webpackChunkName: "search" */'./views/dealer-assess-catalogue2/index.vue'),
          meta:{
            navbar: {
              isShow: true,
              isBack: true
            },
            tabbar: {
              isShow: true,
              active: 2
            },
            title: "数字化全域经销商体系" // 经销商评估类型
          }
        },
        {
          path: '/dealer-assess-list',
          name: 'dealer-assess-list',
          component: ()=> import(/* webpackChunkName: "search" */'./views/dealer-assess-list/index.vue'),
          meta:{
            navbar: {
              isShow: true,
              isBack: true
            },
            tabbar: {
              isShow: true,
              active: 2
            },
            title: "数字化全域经销商体系" // 经销商评估列表
          }
        },
        {
          path: '/dealer-assess-detail',
          name: 'dealer-assess-detail',
          component: ()=> import(/* webpackChunkName: "search" */'./views/dealer-assess-detail/index.vue'),
          meta:{
            navbar: {
              isShow: true,
              isBack: true
            },
            tabbar: {
              isShow: true,
              active: 2
            },
            title: "数字化全域经销商体系" // 经销商评估结果
          }
        },
        {
          path: '/dealer-assess-paper',
          name: 'dealer-assess-paper',
          component: ()=> import(/* webpackChunkName: "search" */'./views/dealer-assess-paper/index.vue'),
          meta:{
            navbar: {
              isShow: true,
              isBack: true
            },
            tabbar: {
              isShow: false,
              active: 2
            },
            title: "数字化全域经销商体系" // 经销商评估问卷
          }
        },
        {
          path: '/dealer-assess-paper-read',
          name: 'dealer-assess-paper-read',
          component: ()=> import(/* webpackChunkName: "search" */'./views/dealer-assess-paper-read/index.vue'),
          meta:{
            navbar: {
              isShow: true,
              isBack: true
            },
            tabbar: {
              isShow: false,
              active: 2
            },
            title: "数字化全域经销商体系" // 经销商评估问卷
          }
        },
        {
          path: '/lesson-type',
          name: 'lesson-type',
          component: ()=> import(/* webpackChunkName: "lessson-type" */'./views/study/lesson-type/index.vue'),
          meta:{
            navbar: {
              isShow: true,
              isBack: true
            },
            tabbar: {
              isShow: true,
              active: 2
            },
            title: "数字化全域经销商体系" // 经销商档案详情
          }
        },
        {
          path: '/lesson-list',
          name: 'lesson-list',
          component: ()=> import(/* webpackChunkName: "lessson-list" */'./views/study/lesson-list/index.vue'),
          meta:{
            navbar: {
              isShow: true,
              isBack: true
            },
            tabbar: {
              isShow: true,
              active: 2
            },
            title: "数字化全域经销商体系" // 经销商档案详情
          }
        },
        {
          path: '/lesson-catalogue',
          name: 'lesson-catalogue',
          component: ()=> import(/* webpackChunkName: "lessson-detail" */'./views/study/lesson-catalogue/index.vue'),
          meta:{
            navbar: {
              isShow: true,
              isBack: true
            },
            tabbar: {
              isShow: true,
              active: 2
            },
            title: "数字化全域经销商体系" // 经销商档案详情
          }
        },
        {
          path: '/lesson-detail',
          name: 'lesson-detail',
          component: ()=> import(/* webpackChunkName: "lessson-detail" */'./views/study/lesson-detail/index.vue'),
          meta:{
            navbar: {
              isShow: true,
              isBack: true
            },
            tabbar: {
              isShow: true,
              active: 2
            },
            title: "数字化全域经销商体系" // 经销商档案详情
          }
        },
        {
          path: '/login',
          name: 'login',
          component: ()=> import('./views/login/index.vue'),
          meta:{
            keepAlive: true,  
            navbar: {
              isShow: true,
              // isBack: true
            },
            tabbar: {
              isShow: true,
              active: 2
            },
            title: "数字化全域经销商体系"
          }
        },
        {
          path: '/login-auth',
          name: 'login-auth',
          component: ()=> import('./views/login-auth/index.vue'),
          meta:{
            keepAlive: true,  
            navbar: {
              isShow: false,
              // isBack: true
            },
            tabbar: {
              isShow: false,
              active: 2
            },
            title: "数字化全域经销商体系"
          }
        },
        {
          path: '/dealer-tools',
          name: 'dealer-tools',
          component: ()=> import(/* webpackChunkName: "search" */'./views/dealer-tools/index.vue'),
          meta:{
            navbar: {
              isShow: true,
              isBack: true
            },
            tabbar: {
              isShow: true,
              active: 2
            },
            title: "数字化全域经销商体系" // 经销商评估类型
          }
        },
        {
          path: '/dealer-roi-list',
          name: 'dealer-roi-list',
          component: ()=> import(/* webpackChunkName: "search" */'./views/dealer-tools/dealer-roi-list/index.vue'),
          meta:{
            navbar: {
              isShow: true,
              isBack: true
            },
            tabbar: {
              isShow: true,
              active: 2
            },
            title: "数字化全域经销商体系" // 经销商评估类型
          }
        },
        {
          path: '/dealer-roi-calculation',
          name: 'dealer-roi-calculation',
          component: ()=> import(/* webpackChunkName: "search" */'./views/dealer-tools/dealer-roi-calculation/index.vue'),
          meta:{
            navbar: {
              isShow: true,
              isBack: true
            },
            tabbar: {
              isShow: true,
              active: 2
            },
            title: "数字化全域经销商体系" // 经销商评估类型
          }
        },
        {
          path: '/dealer-roi-results',
          name: 'dealer-roi-results',
          component: ()=> import(/* webpackChunkName: "search" */'./views/dealer-tools/dealer-roi-results/index.vue'),
          meta:{
            navbar: {
              isShow: true,
              isBack: true
            },
            tabbar: {
              isShow: true,
              active: 2
            },
            title: "数字化全域经销商体系" // 经销商评估类型
          }
        },
        {
          path: '/dealer-roi-topic',
          name: 'dealer-roi-topic',
          component: ()=> import(/* webpackChunkName: "search" */'./views/dealer-tools/dealer-roi-topic/index.vue'),
          meta:{
            navbar: {
              isShow: true,
              isBack: true
            },
            tabbar: {
              isShow: true,
              active: 2
            },
            title: "数字化全域经销商体系" // 经销商评估类型
          }
        },
        {
          path: '/satisfaction',
          name: 'satisfaction',
          component: ()=> import(/* webpackChunkName: "search" */'./views/satisfaction/index.vue'),
          meta:{
            navbar: {
              isShow: true,
              isBack: true
            },
            tabbar: {
              isShow: true,
              active: 2
            },
            title: "数字化全域经销商体系" // 经销商评估类型
          }
        },
        {
          path: '/satisfaction-list',
          name: 'satisfaction-list',
          component: ()=> import(/* webpackChunkName: "search" */'./views/satisfaction/list/index.vue'),
          meta:{
            navbar: {
              isShow: true,
              isBack: true
            },
            tabbar: {
              isShow: true,
              active: 2
            },
            title: "数字化全域经销商体系" 
          }
        },
        {
          path: '/satisfaction-detail',
          name: 'satisfaction-detail',
          component: ()=> import(/* webpackChunkName: "search" */'./views/satisfaction/detail.vue'),
          meta:{
            navbar: {
              isShow: true,
              isBack: true
            },
            tabbar: {
              isShow: true,
              active: 2
            },
            title: "数字化全域经销商体系" 
          }
        },
        {
          path: '/satisfaction-choice',
          name: 'satisfaction-choice',
          component: ()=> import(/* webpackChunkName: "search" */'./views/satisfaction/choice.vue'),
          meta:{
            navbar: {
              isShow: true,
              isBack: true
            },
            tabbar: {
              isShow: true,
              active: 2
            },
            title: "数字化全域经销商体系" 
          }
        },
        {
          path: '/satisfaction-entrance',
          name: 'satisfaction-entrance',
          component: ()=> import(/* webpackChunkName: "search" */'./views/satisfaction/entrance.vue'),
          meta:{
            navbar: {
              isShow: true,
              isBack: true
            },
            tabbar: {
              isShow: true,
              active: 2
            },
            title: "数字化全域经销商体系" 
          }
        },
        {
          path: '/satisfaction-questionnaire',
          name: 'satisfaction-questionnaire',
          component: ()=> import(/* webpackChunkName: "search" */'./views/satisfaction/questionnaire.vue'),
          meta:{
            navbar: {
              isShow: true,
              isBack: true
            },
            tabbar: {
              isShow: true,
              active: 2
            },
            title: "数字化全域经销商体系" 
          }
        },
        {
          path: '/satisfaction-basic-information',
          name: 'satisfaction-basic-information',
          component: ()=> import(/* webpackChunkName: "search" */'./views/satisfaction/basic-information.vue'),
          meta:{
            navbar: {
              isShow: true,
              isBack: true
            },
            tabbar: {
              isShow: true,
              active: 2
            },
            title: "数字化全域经销商体系" 
          }
        },
      ]
    },
    {
      path: '*',
      component:()=>import(/* */ './views/404.vue'),
      meta:{
        functions:""
      }
    }
  ]
})

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if(isChunkLoadFailed){
    // 用路由的replace方法，并没有相当于F5刷新页面，失败的js文件并没有从新请求，会导致一直尝试replace页面导致死循环，而用 location.reload 方法，相当于触发F5刷新页面，虽然用户体验上来说会有刷新加载察觉，但不会导致页面卡死及死循环，从而曲线救国解决该问题
      // const targetPath = $router.history.pending.fullPath;
      router.replace(targetPath);
  }
  
});

export default router;